<div class="container-fluid">
  <div class="row">
    <div class="col-sm-12">
      @if (alertInfo.show) {
        <ngb-alert [type]="alertInfo.type" (closed)="alertInfo.show = false" class="mb-3">
          <strong>{{ alertInfo.type === 'danger' ? 'Error!' : 'Success!' }}</strong>
          <div [innerHTML]="alertInfo.message"></div>
        </ngb-alert>
      }
    </div>
  </div>
  <div class="row">
    <div class="col-sm-5">
      <div class="row g-3">
        <div class="col-12">
          <div class="card shadow-sm">
            <div class="card-header">
              <h3 class="card-title">{{ employeeId ? 'Update Personnel' : 'Create Personnel' }} </h3>
            </div>
            <div class="card-body">
              <employee-consultants-residential-info-form [employee]="employee" [readonly]="readonly"
                (onSavedData)="onResidentialFormSavedData($event)" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-sm-7">
      <div class="col-12">
        <div class="card shadow-sm">
          <div class="card-header">
            <h3 class="card-title">General Info</h3>
          </div>
          <div class="card-body">
            <employee-consultants-general-info-form [employee]="employee" [readonly]="readonly"
              (onSavedData)="onGeneralFormSavedData($event)" />
          </div>
        </div>
      </div>
    </div>
  </div>

  @if (readonly === false) {
    <div class="row mb-4">
      <div class="col-12">
        <div class="d-flex justify-content-center">
          <button type="button" class="btn btn-success" (click)="saveAllForms()" [disabled]="isSaving">
            @if (isSaving) {
              <span class="spinner-border spinner-border-sm me-1" role="status"></span>
            }
            Save
          </button>
        </div>
      </div>
    </div>
  }
  <div class="row mt-1">
    <div class="col-md-12">
      <div class="card shadow-sm">
        <div class="card-header">
          <h3 class="card-title">Previous Jobs</h3>
        </div>
        <div class="card-body">
          <employee-consultants-previous-jobs-form [employeeId]="employeeId" [employee]="employee"
            [employeeWorkCustomerList]="employeeWorkCustomerList" [readonly]="readonly"
            (onSavedData)="onPreviousJobsFormSavedData($event)" />
        </div>
      </div>
    </div>
  </div>
  <div class="row mt-1">
    <div class="col-md-12">
      <div class="card shadow-sm">
        <div class="card-header">
          <h3 class="card-title">Documents</h3>
        </div>
        <div class="card-body">
          <employee-documents [employeeId]="employeeId" [readonly]="readonly"
            (onSavedData)="onDocumentsSavedData($event)" />
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-12">
      <notes-customers-form [readonlyCustomerNotes]="readonly" [customer]="employeeNotes"
        [noteServiceMethod]="employeeConsultantsService" [addNoteMethod]="'createNotes'"
        [deleteNoteMethod]="'deleteNotes'" [sectionAttribute]="'employeeId'" />
    </div>
  </div>
</div>